import styled, { css, keyframes } from 'styled-components/macro';

import { ReactComponent as CheckboxCheckSvg } from 'components/svg/CheckboxCheck.svg';
import { description } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface IInputProps {
  isPulsing: boolean;
}

export const Label = styled.label`
  cursor: pointer;
  display: inline-block;
`;

export const Text = styled.span`
  ${description}

  display: block;
  height: 24px;
  position: relative;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}

  &:before,
  &:after {
    border-radius: 2px;
    content: '';
    display: inline-block;
    height: 22px;
    margin: 0 10px 0 0;
    vertical-align: bottom;
    width: 22px;

    ${({ theme }: IWithThemeProps) => `
      border: 1px solid ${theme.inputBorderColorDefault};
    `}
  }

  &:after {
    left: 0;
    opacity: 0;
    position: absolute;
  }
`;

export const Icon = styled(CheckboxCheckSvg)`
  display: none;
  height: 12px;
  left: 4px;
  position: absolute;
  top: 6px;
  width: 16px;

  [data-svg-class='Icon-stroke'] {
    ${({ theme }: IWithThemeProps) => `
      stroke: ${theme.checkboxCheckStrokeColor};
    `}
  }
`;

const pulse = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
`;

export const Input = styled.input<IInputProps>`
  left: -9999px;
  position: absolute;

  &:focus + ${Text} {
    &:before {
      ${({ theme }: IWithThemeProps) => `
        box-shadow: 0 0 5px ${theme.inputBorderColorFocus};
      `}
    }
  }

  &:checked + ${Text} {
    ${Icon} {
      display: block;
    }
  }

  ${({ isPulsing }) => {
    if (isPulsing) {
      return css`
        + ${Text} {
          &:after {
            animation-delay: 7s;
            animation-duration: 1s;
            animation-iteration-count: infinite;
            animation-name: ${pulse};
            animation-timing-function: ease-out;
          }
        }
      `;
    }

    return '';
  }}
`;
